import { useMemo } from 'react';
import MachinesTopSection from '../../components/machines/MachinesTopSection';
import MachineControlCard from '../../components/machines/control/MachineControlCard';
import { machines } from '../../data/machine/machines';
import useAdvanceTable from '../../hooks/useAdvanceTable';
import AdvanceTableProvider from '../../providers/AdvanceTableProvider';
import { Col, Row } from 'react-bootstrap';
import { WebSocketContext } from '../../providers/WebSocketProvider';
import { useContext, useEffect } from 'react';
import { BallTriangle } from 'react-loader-spinner';
import { useAppContext } from '../../providers/AppProvider';
// HMI PLC MONITOR PARAMETERS

export const columns = [
  {
    // For filtering and searching projects by status
    id: 'status',
    accessorFn: ({ status }) => status.label
  },
  {
    // For searching projects by name
    accessorKey: 'name'
  }
];

const ProjectCardView = () => {
  const { machineData, subscribeToChannel, unsubscribeToChannel } =
    useContext(WebSocketContext);

  console.log('Machine Data in Machine Control Page: REPAINTED');

  const {
    config: { theme }
  } = useAppContext();

  const tableData = useMemo(() => [...machineData.state], [machineData.state]);

  const table = useAdvanceTable({
    data: tableData || [],
    columns,
    pageSize: 10,
    pagination: true,
    sortable: true
  });

  useEffect(() => {
    console.log('Subscribing to machine-all channel');
    subscribeToChannel('machine-all');

    return () => {
      console.log('UNSUBSCRIBING from machine-all channel');
      unsubscribeToChannel();
    };
  }, []);

  if (!machineData.state.length) {
    return (
      <BallTriangle
        height={100}
        width={100}
        radius={5}
        color={theme === 'dark' ? 'white' : '#3874ff'}
        ariaLabel="ball-triangle-loading"
        wrapperStyle={styles.spinnerContainer}
        wrapperClass=""
        visible={true}
      />
    );
  }

  return (
    <div>
      <AdvanceTableProvider {...table}>
        <div className="d-flex flex-wrap mb-4 gap-3 gap-sm-6 align-items-center">
          <h2 className="mb-0">
            <span className="me-3">Machine Parameter Control</span>{' '}
          </h2>
        </div>
        <MachinesTopSection activeView="card" />
        <Row className="g-3 mb-9">
          {table
            .getRowModel()
            .rows.map(row => row.original)
            .map(machine => (
              <Col xs={12} sm={6} xl={4} xxl={3} key={machines.id}>
                <MachineControlCard machine={machine} />
              </Col>
            ))}
        </Row>
      </AdvanceTableProvider>
    </div>
  );
};

const styles = {
  spinnerContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // backgroundColor: 'rgba(0, 0, 0, 0.5)', // Optional: Add a background with some opacity
    zIndex: 1000 // Ensure the spinner is on top
    // backgroundColor: '#000', // Optional: background color
  }
};

export default ProjectCardView;
